import React from 'react';
import { CSVLink } from 'react-csv';


const ExportarCsv = (props) => (
  <CSVLink style={{ color: 'black' }} className="btn btn-light btn-csv" filename={props.nomeArquivo}
           data={props.dadosCsv} separator={';'}>
    Baixar
    <i className="material-icons" style={{ fontSize: '15px', verticalAlign: 'middle' }}>
      &#xe2c4;
    </i>
  </CSVLink>
);

export default ExportarCsv
